(() => {
  'use strict';
  const configNode = document.getElementById('bf26-config');
  if (!configNode) return;
  const config = JSON.parse(configNode.textContent);
  let captureActive = false;
  function closeBlockedPopups() {
    document.querySelectorAll('form.klaviyo-form').forEach(form => {
      const modal = form.closest('[role="dialog"]');
      if (!modal) return;
      const legacy = config.legacyForms.some(id => form.getAttribute('data-testid') === 'klaviyo-form-' + id);
      if (!config.landing && !(captureActive && legacy)) return;
      modal.style.setProperty('display', 'none', 'important');
      if (!modal.dataset.bf26Closed) {
        modal.dataset.bf26Closed = 'true';
        const close = modal.querySelector('.klaviyo-close-form');
        if (close) close.click();
      }
    });
  }
  function tick() {
    const now = Date.now();
    captureActive = now >= config.capture && now < config.end;
    const awarenessActive = now >= config.awareness && now < config.end;
    document.querySelectorAll('[data-bf26-window]').forEach(el => {
      const active = el.dataset.bf26Window === 'capture' ? captureActive : awarenessActive;
      el.hidden = !active;
    });
    document.querySelectorAll('[data-bf26-normal-newsletter]').forEach(el => { el.hidden = captureActive; });
    const total = Math.max(0, Math.floor((config.end - now) / 1000));
    const values = { days: Math.floor(total / 86400), hours: Math.floor(total / 3600) % 24, minutes: Math.floor(total / 60) % 60, seconds: total % 60 };
    document.querySelectorAll('[data-bf26-unit]').forEach(el => { el.textContent = String(values[el.dataset.bf26Unit]).padStart(2, '0'); });
    if (config.landing && now >= config.end && !config.editor) {
      const mount = document.getElementById('bf2026-form');
      if (mount && !mount.dataset.bf26Closed) {
        mount.dataset.bf26Closed = 'true';
        mount.className = 'bf26-closed';
        mount.innerHTML = '<h2>El acceso anticipado ya ha comenzado.</h2><p>La inscripción de esta edición ha terminado.</p><a href="/collections/all">Ver nuestros productos →</a>';
      }
    }
    closeBlockedPopups();
  }
  tick();
  setInterval(tick, 1000);
  document.addEventListener('visibilitychange', tick);
  const observer = new MutationObserver(closeBlockedPopups);
  observer.observe(document.documentElement, { childList: true, subtree: true });
})();
